module.exports = __webpack_public_path__ + "static/media/pic17.76fc83ee.jpg";